import {React,useState} from "react";
import { Container, Button, Row, Col } from "react-bootstrap";
import { Assets } from "../../constants/images";
import Form from "react-bootstrap/Form";
import {Cross} from '../../constants/svg';
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router";


const ForgotPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const history = useHistory();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const onSubmit = async (data) => {
    const { email } = data;
    if (
      data.email === "ezfi@tekrevol.com" 
    ) {
      toast.success("Successfully Submitted !", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setTimeout(() => {
        history.push("/account-verification");
      }, 1500);

    } else {
      toast.error("Invalid Email!", {
        position: toast.POSITION.TOP_RIGHT,
      });

    }
  };

  const [values, setValues] = useState({
    amount: "",
    password: "",
    showPassword: false,
  });

  const myHelper = {
    email: {
      required: "Email is Required",
      pattern: "Invalid Email",
    },
    fullname: {
      required: "Full name is Required",
      minLength: "Min length is 25",
      maxLength: "Max length is 255",
    },
    password: {
      required: "Password is Required",
      minLength: "Min length is 8",
      maxLength: "Max length is 255",
    },
    confrmpassword: {
      required: "Confrmpassword is Required",
      minLength: "Min length is 8",
      maxLength: "Max length is 255",
    },
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    
    <div className="signinform">
      <ToastContainer/>
    <Form onSubmit={handleSubmit(onSubmit)}>
    <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="form-labels">
            Email Address <span>*</span>
          </Form.Label>
          <Form.Control
            className="onboarding-placeholders"
            type="email"
            placeholder="Email address"
            id={"formSignInEmail"}
            {...register("email", {
              required: {
                value: "required",
                message: "Email is required",
              },
              maxLength: {
                value: 255,
                message: "Max length is 255",
              },
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: "Entered value does not match email format",
              },
            })}
          />
          {errors.email && (
            <span className={"validation-error pr-5"} role="alert">
              {errors.email.message}
            </span>
          )}
        </Form.Group>
      <Button className="onboarding-btn mb-3 mt-4" type="submit">
        Continue
      </Button>
    </Form>
  </div>
  )
}

export default ForgotPassword